import { render } from "./DoctorCreditsTab.vue?vue&type=template&id=e34f07d6"
import script from "./DoctorCreditsTab.vue?vue&type=script&lang=js"
export * from "./DoctorCreditsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__